<template>
    <modal
        title="Review Expense"
        ref="modal"
        @close="close"
    >
        <template v-slot:default>
            <div class="expenses-review">
                <table class="table">
                    <tr>
                        <th>Employee:</th>
                        <td>{{ form.employee.name }}</td>
                    </tr>
                    <tr>
                        <th>Date:</th>
                        <td>{{ form.expense_date | date }}</td>
                    </tr>
                    <tr>
                        <th>Amount:</th>
                        <td>£{{ form.expense_amount | money }}</td>
                    </tr>
                    <tr>
                        <th>Vehicle Reg:</th>
                        <td>{{ form.vehicle_reg || 'N/A' }}</td>
                    </tr>
                    <tr>
                        <th>Notes:</th>
                        <td>
                            <div v-html="form.notes_html" />
                        </td>
                    </tr>
                    <tr>
                        <th colspan="2">
                            Attachments:
                        </th>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <attachments-component
                                type="App\EmployeeExpense"
                                :id="form.id"
                                view-only
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>Status:</th>
                        <td>
                            <select
                                class="form-control"
                                v-model="form.status"
                                @change="statusChanged"
                            >
                                <option>Pending</option>
                                <option>Approved</option>
                                <option>Declined</option>
                            </select>
                            <error
                                :errors="errors"
                                name="status"
                            />
                        </td>
                    </tr>
                    <tr v-if="form.status === 'Approved'">
                        <th>Amount Paid:</th>
                        <td>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">£</span>
                                </div>
                                <input
                                    type="number"
                                    min="0.01"
                                    step="0.01"
                                    max="1000"
                                    class="form-control"
                                    v-model="form.payment_amount"
                                >
                            </div>
                            <error
                                :errors="errors"
                                name="payment_amount"
                            />
                        </td>
                    </tr>
                    <tr v-if="form.status === 'Approved'">
                        <th>Payment Method:</th>
                        <td>
                            <select
                                class="form-control"
                                v-model="form.payment_method"
                            >
                                <option :value="null">
                                    Select method...
                                </option>
                                <option>BACS</option>
                                <option>Cash</option>
                            </select>
                        </td>
                        <error
                            :errors="errors"
                            name="payment_method"
                        />
                    </tr>
                    <tr v-if="form.reviewer">
                        <th>Reviewer:</th>
                        <td>
                            {{ form.reviewer.name }}
                        </td>
                    </tr>
                </table>
            </div>
        </template>
        <template v-slot:footer>
            <button
                class="btn btn-primary"
                @click="save"
            >
                Save
            </button>
            <button
                class="btn btn-default"
                @click="close"
            >
                Close
            </button>
        </template>
    </modal>
</template>

<script>
import AttachmentsComponent from '../../AttachmentsComponent.vue';
import Service from '../../../services/EmployeeExpensesService';
import UsesErrors from '../../../mixins/UsesErrors';
import UsesInfoMessage from '../../../mixins/UsesInfoMessage';
export default {
    components: { AttachmentsComponent },
    mixins: [
        UsesErrors,
        UsesInfoMessage,
    ],
    props: {
        expense: {
            required: true,
            type: Object,
        }
    },
    data () {
        return {
            form: {},
        };
    },
    watch: {
        expense: {
            immediate: true,
            handler () {
                this.form = {...this.expense};
            }
        }
    },
    mounted () {
        this.$refs.modal.open();
    },
    methods: {
        close() {
            this.$emit('close');
        },

        statusChanged () {
            if (this.form.status === 'Approved' && !this.form.payment_amount) {
                this.form.payment_amount = this.form.expense_amount;
            } else {
                this.form.payment_amount = null;
                this.form.payment_method = null;
            }
        },

        save () {
            this.clearErrors();
            Service.save(this.form).then(res => {
                this.form = res.data;
                this.setInfoMessage('Expense saved successfully');
            }).catch(err => {
                this.captureRequestErrors(err);
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/expenses/ReviewModal.vue